import { forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const loadFilterOptionsEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetPayload(MarkoutAction.loadFilterOptions.started),
    switchMap((params) => {
      const { reportId, jobId } = params;
      const requests = reportId !== undefined && jobId !== undefined
        ? {
          servers: moApi.getReportServers(reportId, jobId),
          accountGroups: moApi.getReportAccountGroups(reportId, jobId),
          accounts: moApi.getReportAccounts(reportId, jobId),
          symbols: moApi.getReportSymbols(reportId, jobId),
        }
        : {
          servers: moApi.getDashboardServers(),
          accountGroups: moApi.getDashboardAccountGroups(),
          accounts: moApi.getDashboardAccounts(),
          symbols: moApi.getDashboardSymbols(),
        };

      return forkJoin(requests).pipe(
        map((res) => MarkoutAction.loadFilterOptions.done({
          params,
          result: {
            servers: res.servers.servers,
            accountGroups: res.accountGroups.accountGroups,
            accounts: res.accounts.accounts,
            symbols: res.symbols.symbols,
          },
        })),
        catchApiError((error) => [
          MarkoutAction.loadFilterOptions.failed({ params, error }),
        ]),
      );
    }),
  );
